import {
  type AppLocale,
  defaultCountry,
  liveCountries,
  markets,
} from "@/config/markets";

export type { AppLocale };

/** The locales of the live markets. */
export const appLocales: readonly AppLocale[] = liveCountries.map(
  (code) => markets[code].locale,
);
export const defaultAppLocale: AppLocale = markets[defaultCountry].locale;

export function isAppLocale(
  value: string | null | undefined,
): value is AppLocale {
  if (!value) return false;
  return appLocales.includes(value as AppLocale);
}

export function resolveAppLocale(value: string | null | undefined): AppLocale {
  return isAppLocale(value) ? value : defaultAppLocale;
}

/** hreflang alternates: one URL per live locale, plus `x-default`. */
export function getLanguageAlternates(
  urlFor: (locale: AppLocale) => string,
): Record<string, string> {
  return {
    ...Object.fromEntries(appLocales.map((locale) => [locale, urlFor(locale)])),
    "x-default": urlFor(defaultAppLocale),
  };
}
